import { Link, useLocation } from 'react-router-dom';
import { SchemaBreadcrumb } from '@/components/feature/SchemaOrg';

interface ServiceBreadcrumbProps {
  currentTitle: string;
}

export function ServiceBreadcrumb({ currentTitle }: ServiceBreadcrumbProps) {
  const location = useLocation();
  const breadcrumbItems = [
    { name: 'Inicio', url: 'https://toldos-malaga.es/' },
    { name: currentTitle, url: `https://toldos-malaga.es${location.pathname}` },
  ];

  return (
    <>
      <SchemaBreadcrumb items={breadcrumbItems} />
      <nav aria-label="Breadcrumb" className="w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-28 pb-2">
        <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
          <li>
            <Link to="/" className="hover:text-primary-500 transition-colors duration-200">
              Inicio
            </Link>
          </li>
          <li>
            <i className="ri-arrow-right-s-line text-xs"></i>
          </li>
          <li className="text-foreground-700 font-medium truncate max-w-[200px] md:max-w-xs">
            {currentTitle}
          </li>
        </ol>
      </nav>
    </>
  );
}

export function SchemaService({
  name,
  description,
  priceRange,
}: {
  name: string;
  description: string;
  priceRange?: string;
}) {
  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    description,
    provider: {
      '@type': 'LocalBusiness',
      '@id': 'https://toldos-malaga.es/#business',
      name: 'Toldos Málaga',
      url: 'https://toldos-malaga.es/',
      telephone: '+34951120770',
      email: 'info@toldos-malaga.es',
      image: 'https://toldos-malaga.es/og-image.jpg',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Calle Pacífico 54, San Andrés',
        addressLocality: 'Málaga',
        addressRegion: 'Málaga',
        addressCountry: 'ES',
        postalCode: '29003',
      },
      areaServed: {
        '@type': 'City',
        name: 'Málaga',
      },
    },
    areaServed: {
      '@type': 'City',
      name: 'Málaga',
    },
  };

  if (priceRange) {
    const numericPrice = parseInt(priceRange.replace(/[^0-9]/g, ''), 10);
    schema.offers = {
      '@type': 'Offer',
      priceSpecification: {
        '@type': 'PriceSpecification',
        price: numericPrice || 0,
        priceCurrency: 'EUR',
      },
    };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}